const initialState = {
  coursesCount: null
} as any;

const user = (state: any = initialState, action: any) => {
  switch (action.type) {
    case 'RECEIVE_USER_PROFILE':
      return {
        ...state,
        ...action.profile,
        isFetching: false
      };
    case 'RECEIVE_USER_PROFILE_ERROR':
      return {
        ...state,
        error: action.error
      };
    case 'REFRESH_USER_PROFILE':
      return {
        ...state,
        ...action.user,
        isFetching: true
      };
    case 'REFRESH_USER_PROFILE_SUCCESS':
      return {
        ...state,
        isFetching: false
      };
    case 'REFRESH_USER_PROFILE_ERROR':
      return {
        ...state,
        isFetching: false
      };
    case 'RECEIVE_COURSES_COUNT':
      return {
        ...state,
        coursesCount: action.count
      };
    case 'CLEAN_USER_PROFILE':
      return {
        ...initialState
      };
    case 'RECEIVE_USER_SESSION_COUNT':
      return {
        ...state,
        sessionCount: action.count
      };
    case 'RECEIVE_USER_LESSONPAGE_COUNT':
      return {
        ...state,
        lessonPageCount: action.count
      };
    default:
      return state;
  }
};

export default user;
